import React from 'react';
import i18next from 'i18next';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';

import { freqReport } from 'lib/api/freq';
import { getFormat, makeGraph } from 'lib/commonLib';

import CurrentStatus from 'components/atoms/CurrentStatus';
import OutlinedButton from 'components/atoms/OutlinedButton';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const targetGraphList = [
  {
    title: i18next.t('CTR'),
    data: {
      line: [
        'CW_CLICK_RATE',
        'SR_CLICK_RATE',
        'HU_CLICK_RATE',
        'RM_CLICK_RATE',
      ],
    },
    yAxisData: {
      left: {
        CW_CLICK_RATE: { isPercent: true },
        SR_CLICK_RATE: { isPercent: true },
        HU_CLICK_RATE: { isPercent: true },
        RM_CLICK_RATE: { isPercent: true },
      },
      right: {},
    },
    customizeData: {
      CW_CLICK_RATE: {
        tooltipFormat: '0.000',
        isPercent: true,
      },
      SR_CLICK_RATE: {
        tooltipFormat: '0.000',
        isPercent: true,
      },

      HU_CLICK_RATE: {
        tooltipFormat: '0.000',
        isPercent: true,
      },
      RM_CLICK_RATE: {
        tooltipFormat: '0.000',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('세션ROAS'),
    data: {
      line: [
        'CW_SESSION_FREQ_ROAS',
        'SR_SESSION_FREQ_ROAS',
        'HU_SESSION_FREQ_ROAS',
        'RM_SESSION_FREQ_ROAS',
      ],
    },
    yAxisData: {
      left: {
        CW_SESSION_FREQ_ROAS: { isPercent: true },
        SR_SESSION_FREQ_ROAS: { isPercent: true },
        HU_SESSION_FREQ_ROAS: { isPercent: true },
        RM_SESSION_FREQ_ROAS: { isPercent: true },
      },
      right: {},
    },
    customizeData: {
      CW_SESSION_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      SR_SESSION_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      HU_SESSION_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      RM_SESSION_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('총ROAS'),
    data: {
      line: ['CW_FREQ_ROAS', 'SR_FREQ_ROAS', 'HU_FREQ_ROAS', 'RM_FREQ_ROAS'],
    },
    yAxisData: {
      left: {
        CW_FREQ_ROAS: { isPercent: true },
        SR_FREQ_ROAS: { isPercent: true },
        HU_FREQ_ROAS: { isPercent: true },
        RM_FREQ_ROAS: { isPercent: true },
      },
      right: {},
    },
    customizeData: {
      CW_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      SR_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      HU_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      RM_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('eCPM'),
    data: {
      line: ['CW_ECPM', 'SR_ECPM', 'HU_ECPM', 'RM_ECPM'],
    },
    yAxisData: {
      left: {
        CW_ECPM: true,
        SR_ECPM: true,
        HU_ECPM: true,
        RM_ECPM: true,
      },
      right: {},
    },
  },
  {
    title: i18next.t('노출'),
    data: {
      line: [
        'CW_PAR_EPRS_CNT',
        'SR_PAR_EPRS_CNT',
        'HU_PAR_EPRS_CNT',
        'RM_PAR_EPRS_CNT',
      ],
    },
    yAxisData: {
      left: {
        CW_PAR_EPRS_CNT: true,
        SR_PAR_EPRS_CNT: true,
        HU_PAR_EPRS_CNT: true,
        RM_PAR_EPRS_CNT: true,
      },
      right: {},
    },
  },
  {
    title: i18next.t('소진'),
    data: {
      line: [
        'CW_ADVRTS_AMT',
        'SR_ADVRTS_AMT',
        'HU_ADVRTS_AMT',
        'RM_ADVRTS_AMT',
      ],
    },
    yAxisData: {
      left: {
        CW_ADVRTS_AMT: true,
        SR_ADVRTS_AMT: true,
        HU_ADVRTS_AMT: true,
        RM_ADVRTS_AMT: true,
      },
      right: {},
    },
  },
];

const graphList = [
  {
    title: 'CTR',
    data: { line: ['CLICK_RATE', 'WEB_CLICK_RATE', 'MOBILE_CLICK_RATE'] },
    yAxisData: {
      left: { ADVER_CNT: true },
      right: { CLICK_RATE: true, isPercent: true },
    },
    customizeData: {
      CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      MOBILE_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },

  {
    title: i18next.t('세션ROAS'),
    data: {
      line: [
        'SESSION_FREQ_ROAS',
        'WEB_SESSION_FREQ_ROAS',
        'MOBILE_SESSION_FREQ_ROAS',
      ],
    },
    yAxisData: {
      left: {
        SESSION_FREQ_ROAS: { isPercent: true },
        WEB_SESSION_FREQ_ROAS: { isPercent: true },
        MOBILE_SESSION_FREQ_ROAS: { isPercent: true },
      },
      right: {},
    },
    customizeData: {
      SESSION_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_SESSION_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      MOBILE_SESSION_FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('총ROAS'),
    data: { line: ['FREQ_ROAS', 'WEB_FREQ_ROAS', 'MOBILE_FREQ_ROAS'] },
    yAxisData: {
      left: {
        FREQ_ROAS: { isPercent: true },
        WEB_FREQ_ROAS: { isPercent: true },
        MOBILE_FREQ_ROAS: { isPercent: true },
      },
      right: {},
    },
    customizeData: {
      FREQ_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_FREQ_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      MOBILE_FREQ_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('전환율'),
    data: { line: ['CONV_RATE', 'WEB_CONV_RATE', 'MOBILE_CONV_RATE'] },
    yAxisData: {
      left: {
        CONV_RATE: { isPercent: true },
        WEB_CONV_RATE: { isPercent: true },
        MOBILE_CONV_RATE: { isPercent: true },
      },
      right: {},
    },
    customizeData: {
      CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      MOBILE_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('eCPM'),
    data: { line: ['ECPM', 'WEB_ECPM', 'MOBILE_ECPM'] },
    yAxisData: {
      left: {
        ECPM: true,
        WEB_ECPM: true,
        MOBILE_ECPM: true,
      },
      right: {},
    },
  },
  {
    title: i18next.t('노출'),
    data: { line: ['PAR_EPRS_CNT', 'WEB_PAR_EPRS_CNT', 'MOBILE_PAR_EPRS_CNT'] },
    yAxisData: {
      left: {
        PAR_EPRS_CNT: true,
        WEB_PAR_EPRS_CNT: true,
        MOBILE_PAR_EPRS_CNT: true,
      },
      right: {},
    },
  },
  {
    title: i18next.t('소진'),
    data: { line: ['ADVRTS_AMT', 'WEB_ADVRTS_AMT', 'MOBILE_ADVRTS_AMT'] },
    yAxisData: {
      left: {
        ADVRTS_AMT: true,
        WEB_ADVRTS_AMT: true,
        MOBILE_ADVRTS_AMT: true,
      },
      right: {},
    },
  },
];

class FreqSttStatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      infoMessage: '',
      loading: false,
      error: false,
    };
  }

  getData = () => {
    const { params, locale, t, location } = this.props;
    const { uri } = queryString.parse(location.search);

    const { sDate, eDate } = params;
    const format = getFormat(locale);

    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    freqReport({ ...params, uri })
      .then((response) => {
        const { data } = response.data;
        this.setState({
          ...this.state,
          primitiveData: data.platformDatas,
          targetPrimitiveData: data.targetingDatas,
          loading: false,
          error: false,
        });
        this.handleChangeGraph(graphList[0], 0)();
        this.handleChangeTargetGraph(targetGraphList[0], 0)();
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    let color = '';

    return <span style={{ color }}>{originalDate}</span>;
  };

  xAxisTick = (tickProps) => {
    const { x, y, payload } = tickProps;
    const { value } = payload;
    let fill = '';

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {value}
      </text>
    );
  };

  handleChangeTargetGraph =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      index
    ) =>
    (e) => {
      const { targetPrimitiveData } = this.state;
      const primitiveData = targetPrimitiveData;

      if (typeof data !== 'undefined') {
        const {
          graphData,
          dataKeys,
          customizeData,
          keyLabel,
          stackId,
          referenceData,
        } = makeGraph({ data, customize, primitiveData, referenceLine });

        const result = (
          <MultiplexChart
            width="100%"
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
            key={title}
            referenceLine={referenceData}
          />
        );
        console.log(result);

        this.setState({
          ...this.state,
          curTargetGraphComponent: result,
          targetSelectedIdx: index,
        });
      }
    };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   * graphData json, index
   */
  handleChangeGraph =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      index
    ) =>
    (e) => {
      const { primitiveData } = this.state;

      if (typeof data !== 'undefined') {
        const {
          graphData,
          dataKeys,
          customizeData,
          keyLabel,
          stackId,
          referenceData,
        } = makeGraph({ data, customize, primitiveData, referenceLine });
        const result = (
          <MultiplexChart
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
            key={title}
            referenceLine={referenceData}
          />
        );

        this.setState({
          ...this.state,
          curGraphComponent: result,
          selectedIdx: index,
        });
      }
    };

  render() {
    const { handleRefesh, handleChangeGraph, handleChangeTargetGraph } = this;
    const { t } = this.props;

    const {
      infoMessage,
      curGraphComponent,
      curTargetGraphComponent,
      selectedIdx,
      targetSelectedIdx,
      primitiveData,
      targetPrimitiveData,
      loading,
      error,
    } = this.state;

    return (
      <>
        <SwitchingArea
          title={
            <>
              <InfoTitleArea
                title={t('프리퀀시 디바이스별 그래프')}
                tooltipTitle={infoMessage}
                iconType="fainfoCircle"
                iconColor="graph"
              />
            </>
          }
          handleRefesh={handleRefesh}
        >
          {loading || error ? (
            <CurrentStatus type={loading ? 'loading' : error && 'error'} />
          ) : (
            <>
              <ChartButtonWrap>
                {graphList.map((item, index) => {
                  return (
                    <OutlinedButton
                      key={item.title}
                      onClick={handleChangeGraph(item, index)}
                      selected={selectedIdx === index}
                      disabled={!Boolean(primitiveData)}
                    >
                      {item.title}
                    </OutlinedButton>
                  );
                })}
              </ChartButtonWrap>
              <ContentsWrap contentsCount={1}>{curGraphComponent}</ContentsWrap>
            </>
          )}
        </SwitchingArea>
        <SwitchingArea
          title={
            <>
              <InfoTitleArea
                title={t('프리퀀시 타겟팅별 그래프')}
                tooltipTitle={infoMessage}
                iconType="fainfoCircle"
                iconColor="graph"
              />
            </>
          }
          handleRefesh={handleRefesh}
        >
          {loading || error ? (
            <CurrentStatus type={loading ? 'loading' : error && 'error'} />
          ) : (
            <>
              <ChartButtonWrap>
                {targetGraphList.map((item, index) => {
                  return (
                    <OutlinedButton
                      key={item.title}
                      onClick={handleChangeTargetGraph(item, index)}
                      selected={targetSelectedIdx === index}
                      disabled={!Boolean(targetPrimitiveData)}
                    >
                      {item.title}
                    </OutlinedButton>
                  );
                })}
              </ChartButtonWrap>
              <ContentsWrap contentsCount={1}>
                {curTargetGraphComponent}
              </ContentsWrap>
            </>
          )}
        </SwitchingArea>
      </>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withTheme(FreqSttStatisticsGraph))
  )
);
